// The Aviah geometric signature: an open circular arc + two diagonal parallel
// lines. Thin strokes only — never distorted, never glowed.
export const AviahMark = ({ className = "", stroke = "currentColor", strokeWidth = 3.5 }) => (
  <svg viewBox="0 0 120 100" fill="none" className={className} aria-hidden="true">
    <path
      d="M 92 22 A 45 45 0 1 0 92 78"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
    />
    <line x1="66" y1="94" x2="90" y2="6" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
    <line x1="82" y1="94" x2="106" y2="6" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" />
  </svg>
);

// Large low-opacity watermark used across sections, footer and mobile menu.
export const AviahWatermark = ({ className = "" }) => (
  <div className={`pointer-events-none select-none ${className}`} aria-hidden="true">
    <AviahMark className="h-full w-full text-[#C6A46A]" strokeWidth={2.5} />
  </div>
);
